module.exports = __webpack_public_path__ + "img/S.fc4b5bed.svg";